/*
 * popup-signup.js
 *
 * Intercepts submission of the popup newsletter form (when rendered with
 * enable_phone: true in snippets/newsletter-form.liquid), validates inputs,
 * and POSTs to the popup-signup backend which creates a Shopify customer
 * with email + SMS marketing consent via Admin API customerCreate.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var E164_RE = /^\+[1-9]\d{6,14}$/;
  var LEAP_YEAR = 2000; // per validare giorno/mese senza anno: il 29 febbraio è ammesso

  // Data di nascita facoltativa (giorno + mese). Ritorna:
  //   ''        → nessuna data (entrambi vuoti)
  //   'MM-DD'   → data valida
  //   null      → incompleta o inesistente (es. 31 aprile)
  function readBirthday(form) {
    var day = (form.querySelector('select[name="birthday_day"]') || {}).value || '';
    var month = (form.querySelector('select[name="birthday_month"]') || {}).value || '';
    if (!day && !month) return '';
    if (!day || !month) return null;
    var d = new Date(LEAP_YEAR, parseInt(month, 10) - 1, parseInt(day, 10));
    if (d.getMonth() !== parseInt(month, 10) - 1) return null;
    return month + '-' + day;
  }

  // Sostituisce i numeri 01-12 con i nomi dei mesi nella lingua della pagina.
  function localizeMonths(form) {
    var select = form.querySelector('[data-popup-signup-month-select]');
    if (!select || !window.Intl || !Intl.DateTimeFormat) return;
    var locale = form.dataset.popupSignupLocale || 'it';
    try {
      var fmt = new Intl.DateTimeFormat(locale, { month: 'long' });
      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        if (!opt.value) continue;
        var name = fmt.format(new Date(LEAP_YEAR, parseInt(opt.value, 10) - 1, 1));
        opt.textContent = name.charAt(0).toUpperCase() + name.slice(1);
      }
    } catch (e) {}
  }

  function buildE164(country, local) {
    var digits = String(local || '').replace(/\D+/g, '').replace(/^0+/, '');
    return (country || '') + digits;
  }

  function decodeEntities(s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(s || '');
    return ta.value;
  }

  function showStatus(form, kind, message) {
    var box = form.querySelector('[data-popup-signup-status]');
    if (!box) return;
    box.hidden = false;
    var cls = kind === 'success' ? 'form-status__message--success' : 'form-status__message--error';
    box.textContent = '';
    var span = document.createElement('span');
    span.className = 'form-status__message ' + cls;
    span.setAttribute('tabindex', '0');
    span.setAttribute('data-form-status', '');
    span.textContent = decodeEntities(message);
    box.appendChild(span);
    try { span.focus(); } catch (e) {}
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function hideInner(form) {
    var inner = form.querySelector('[data-popup-signup-inner]');
    if (inner) inner.style.display = 'none';
  }

  function errorMessage(form, code) {
    var ds = form.dataset;
    switch (code) {
      case 'invalid_email': return ds.popupSignupErrEmail;
      case 'invalid_phone': return ds.popupSignupErrPhone;
      case 'already_subscribed':
      case 'phone_taken': return ds.popupSignupErrAlready;
      case 'invalid_birthday': return ds.popupSignupErrBirthday;
      default: return ds.popupSignupErrServer;
    }
  }

  function onSubmit(e) {
    var form = e.currentTarget;
    e.preventDefault();

    if (form.dataset.popupSignupSubmitting === '1') return;

    var endpoint = form.dataset.popupSignupEndpoint;
    var locale = form.dataset.popupSignupLocale || 'it';

    var email = (form.querySelector('input[name="email"]') || {}).value || '';
    var country = (form.querySelector('select[name="phone_country"]') || {}).value || '';
    var phoneLocal = (form.querySelector('input[name="phone"]') || {}).value || '';

    email = email.trim().toLowerCase();
    var phone = buildE164(country, phoneLocal);

    if (!EMAIL_RE.test(email)) {
      showStatus(form, 'error', errorMessage(form, 'invalid_email'));
      return;
    }
    if (!E164_RE.test(phone)) {
      showStatus(form, 'error', errorMessage(form, 'invalid_phone'));
      return;
    }
    var birthday = readBirthday(form);
    if (birthday === null) {
      showStatus(form, 'error', errorMessage(form, 'invalid_birthday'));
      return;
    }

    var payload = { email: email, phone: phone, locale: locale };
    if (birthday) payload.birthday = birthday;

    form.dataset.popupSignupSubmitting = '1';
    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      mode: 'cors',
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        form.dataset.popupSignupSubmitting = '0';
        if (btn) btn.removeAttribute('disabled');

        if (res.status === 200 && res.body && res.body.ok) {
          showStatus(form, 'success', form.dataset.popupSignupSuccessMsg);
          hideInner(form);
          try {
            document.dispatchEvent(new CustomEvent('popup-signup:success', {
              detail: { email: email, customer_id: res.body.customer_id }
            }));
          } catch (e) {}
          return;
        }
        var code = (res.body && res.body.error) || 'server_error';
        showStatus(form, 'error', errorMessage(form, code));
      })
      .catch(function () {
        form.dataset.popupSignupSubmitting = '0';
        if (btn) btn.removeAttribute('disabled');
        showStatus(form, 'error', errorMessage(form, 'server_error'));
      });
  }

  function bind(form) {
    if (form.dataset.popupSignupBound === '1') return;
    form.dataset.popupSignupBound = '1';
    localizeMonths(form);
    form.addEventListener('submit', onSubmit);
  }

  function bindAll() {
    var forms = document.querySelectorAll('form[data-popup-signup]');
    for (var i = 0; i < forms.length; i++) bind(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // Re-bind when popup is inserted dynamically (section rerender in theme editor, etc.)
  document.addEventListener('shopify:section:load', bindAll);
  var mo = new MutationObserver(function () { bindAll(); });
  mo.observe(document.body, { childList: true, subtree: true });

  // ---- Coesistenza con il carrello UpCart ----
  // Il popup del tema blocca scroll e focus della pagina: se è aperto insieme al
  // carrello UpCart, la cliente non riesce a usare il carrello (es. il campo del
  // codice sconto perde il focus). Regola di Andrea (2026-10-09): con il carrello
  // aperto il popup di iscrizione si chiude e conta come chiuso dalla cliente.
  // La chiusura passa dal pulsante del popup, così il tema libera focus e scroll
  // e memorizza la chiusura come per un clic sulla X.
  var UPCART_WAIT_MS = 15000; // l'API di UpCart si carica dopo questo script
  var UPCART_POLL_MS = 250;
  var SIGNUP_POPUP_SELECTOR = '[data-popup][data-is-signup="true"]';
  var upcartOpen = false;

  function closeSignupPopups() {
    var popups = document.querySelectorAll(SIGNUP_POPUP_SELECTOR + '.visible');
    for (var i = 0; i < popups.length; i++) {
      var dismiss = popups[i].querySelector('[data-dismiss-popup]');
      if (dismiss) dismiss.click();
    }
  }

  // Se il popup compare (timer del tema) mentre il carrello è aperto, si chiude subito.
  function watchSignupPopups() {
    var popups = document.querySelectorAll(SIGNUP_POPUP_SELECTOR);
    for (var i = 0; i < popups.length; i++) {
      if (popups[i].dataset.popupSignupUpcartWatch === '1') continue;
      popups[i].dataset.popupSignupUpcartWatch = '1';
      new MutationObserver(function () {
        if (upcartOpen) closeSignupPopups();
      }).observe(popups[i], { attributes: true, attributeFilter: ['class'] });
    }
  }

  function hookUpcart() {
    if (typeof window.upcartSubscribeCartOpened !== 'function' ||
        typeof window.upcartSubscribeCartClosed !== 'function') return false;
    window.upcartSubscribeCartOpened(function () {
      upcartOpen = true;
      closeSignupPopups();
    });
    window.upcartSubscribeCartClosed(function () { upcartOpen = false; });
    return true;
  }

  function initUpcartGuard() {
    watchSignupPopups();
    var waited = 0;
    (function tryHook() {
      if (hookUpcart()) return;
      waited += UPCART_POLL_MS;
      if (waited < UPCART_WAIT_MS) setTimeout(tryHook, UPCART_POLL_MS);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpcartGuard);
  } else {
    initUpcartGuard();
  }
})();
